import { Component, computed, EventEmitter, Input, input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';

const LOADER_ITEM = { loadingMore: true, disabled: true };

@Component({
  selector: 'app-searchable-select',
  imports: [FormsModule, NgSelectComponent, NgOptionTemplateDirective],
  templateUrl: './searchable-select.html',
  styleUrl: './searchable-select.scss',
  host: {
    '[attr.tabindex]': '-1',
  },
})
export class SearchableSelect implements OnInit {
  readonly items = input<any[]>([]);

  @Input() bindLabel = '';

  @Input() bindValue = '';

  @Input() placeholder = 'Select';

  @Input() searchable = true;

  @Input() clearable = true;

  @Input() disabled = false;

  @Input() model: any;

  @Input() virtualScroll = true;

  readonly loadingMore = input(false);

  @Output() modelChange = new EventEmitter<any>();

  @Output() search = new EventEmitter<string>();

  @Output() scrollToEnd = new EventEmitter<void>();

  protected readonly loaderItem = LOADER_ITEM;

  private lastSearchTerm = '';

  protected readonly displayItems = computed(() =>
    this.loadingMore() ? [...this.items(), LOADER_ITEM] : this.items(),
  );

  onChange(value: any) {
    this.model = value;
    this.modelChange.emit(value);
  }

  ngOnInit() {
    this.search.emit('');
  }

  onSearch(event: { term: string; items: any[] }) {
    this.lastSearchTerm = event.term ?? '';
    this.search.emit(event.term);
  }

  onClose() {
    if (!this.lastSearchTerm) {
      return;
    }
    this.lastSearchTerm = '';
    this.search.emit('');
  }

  onScrollToEnd() {
    this.scrollToEnd.emit();
  }
}
